import { FC } from "react";
import Container from "react-bootstrap/Container";
import Alert from "react-bootstrap/Alert";
import { Navigate } from "react-router-dom";
import { useRouteParams } from "app/route/route";
import { deleteReportVersionDeliverableFileRoute, reportVersionDeliverableFilesRoute } from "app/route/Routes";
import { NavigationScreen } from "app/component/screen/NavigationScreen";
import { useDeleteReportDeliverableFileMutation, useReportDeliverableFileQuery } from "app/api/graph/types";
import { reportDeliverableFileGraphId } from "app/api/graph/helpers";
import { RouteBreadcrumbs } from "app/route/RouteBreadcrumbs";
import { LoadingScreen } from "app/component/screen/LoadingScreen";
import { ErrorScreen } from "app/component/screen/ErrorScreen";
import { ConfirmDelete } from "app/component/form/ConfirmDelete";

export const DeleteReportVersionDeliverableFileScreen: FC = () => {
    const { reportId, versionId, fileId } = useRouteParams(deleteReportVersionDeliverableFileRoute);
    const { data, loading, error } = useReportDeliverableFileQuery({
        variables: { fileId: reportDeliverableFileGraphId(fileId) },
    });
    const [deleteFile, { data: deleteData, loading: deleting, error: deleteError }] =
        useDeleteReportDeliverableFileMutation({
            variables: { input: { id: reportDeliverableFileGraphId(fileId) } },
        });
    const file = data?.reportDeliverableFile;

    if (loading) {
        return <LoadingScreen />;
    }
    if (error) {
        return <ErrorScreen title="Error" message={error.message} />;
    }
    if (!file) {
        return <ErrorScreen title="Error" message="Not found." />;
    }
    if (deleteData?.deleteReportDeliverableFile) {
        return <Navigate to={reportVersionDeliverableFilesRoute.build({ reportId, versionId })} />;
    }

    return (
        <NavigationScreen>
            <Container>
                <RouteBreadcrumbs route={deleteReportVersionDeliverableFileRoute} />
                <h1>{file.reportMediaObject.originalName}</h1>
                {deleteError ? <Alert variant="danger">{deleteError.message}</Alert> : null}
                <p>Are you sure that you want to permanently delete this file from this report version?</p>
                <ConfirmDelete onConfirm={() => deleteFile()} deleting={deleting} />
            </Container>
        </NavigationScreen>
    );
};
